import { render, staticRenderFns } from "./ClientLogoAttachment.vue?vue&type=template&id=14459031&scoped=true"
import script from "./ClientLogoAttachment.vue?vue&type=script&lang=ts"
export * from "./ClientLogoAttachment.vue?vue&type=script&lang=ts"
import style0 from "./ClientLogoAttachment.vue?vue&type=style&index=0&id=14459031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14459031",
  null
  
)

export default component.exports